import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import { AuthContext } from "../../providers/AuthProvider";
import astrounautStandingWave from "../../assets/posesPNG/astronout-standing-wave.png";
import "./CompleteProfileCard.css";

// Hook customizado para verificar se o perfil está completo
export const useProfileComplete = () => {
  const { user } = useContext(AuthContext);

  const checkList = {
    userAVatar: !!user?.avatar,
    isBirthDateFilled: !!user?.birthdate,
    isSalaryFilled: user?.salary && user.salary > 0,
    isContractTypeFilled: !!user?.contractType,
    isWorkModelFilled: !!user?.workModel,
    isSeniorityLevelFilled: !!user?.seniorityLevel,
    isLinkedinFilled: !!user?.linkedinUrl,
    isCulturalFitFilled: user?.isCulturalFitFilled,
    isSelfieLetterFilled: user?.isSelfieLetterFilled,
    isTalentKnowledgeAreaFilled: user?.isTalentKnowledgeAreaFilled,
    isTalentKnowledgeSkillFilled: user?.isTalentKnowledgeSkillFilled,
    isBioFilled: !!user?.bio,
  };

  const contarTrues = (obj) => {
    let contador = 0;
    for (let key in obj) {
      if (obj[key] === true) {
        contador++;
      }
    }
    return contador;
  };

  const totalCompleted = contarTrues(checkList);
  const isProfileComplete = totalCompleted >= Object.keys(checkList).length;

  return { isProfileComplete, totalCompleted, checkList };
};

export const CompleteProfileCard = ({ showButton = true }) => {
  const navigate = useNavigate();
  const { isProfileComplete, totalCompleted } = useProfileComplete();

  if (isProfileComplete) {
    return <></>;
  }

  return (
    <div className="boxCompleteProfile">
      <div className="cardCompleteProfile">
        <div className="cardLeft">
          <LinearProgress
            sx={{
              height: 12,
              width: "150px",
              borderRadius: 5,
              boxSizing: "border-box",
              [`&.${linearProgressClasses.colorPrimary}`]: {
                backgroundColor: "#FFFFFF",
                border: "2px solid #FFFFFF",
              },
              [`& .${linearProgressClasses.bar}`]: {
                borderRadius: "5px 0px 0px 5px",
                backgroundColor: "#57BAB8",
              },
            }}
            value={parseFloat(((totalCompleted / 11) * 100).toFixed(2))}
            variant="determinate"
          />
          <div className="textProfile">Complete seu<br />perfil</div>

          <div className="textProfileSUb">
            Perfis completos e de<br />qualidade aumentam em 4,5<br />vezes suas chances de ser contratado por clientes.
          </div>

          {showButton && (
            <div
              className="button"
              onClick={() => navigate("/settings/status")}
            >
              Clique aqui
            </div>
          )}
        </div>

        <div className="cardRigth">
          <img
            src={astrounautStandingWave}
            alt="backgroud img"
          />
        </div>
      </div>
    </div>
  );
};

